import React from "react";
import { Crown } from "./CrownIcon";
import { Coffee } from "lucide-react";

export const LiveBar = ({ onWatch }) => {
    return (
        <div
            data-testid="live-bar"
            className="sticky top-0 z-40 w-full bg-black border-b-2 border-kickgreen"
        >
            <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3 text-white">
                <div className="flex items-center gap-2">
                    <span
                        className="w-3 h-3 bg-kickgreen rounded-full animate-pulse-glow"
                        aria-hidden
                    />
                    <span className="font-anton uppercase tracking-widest text-sm">
                        Live on Kick
                    </span>
                </div>
                <span className="hidden sm:inline-block w-px h-5 bg-white/20" />
                <div className="hidden sm:flex items-center gap-2">
                    <Crown className="w-5 h-4" color="#FF2E93" />
                    <span className="font-graffiti text-skyblue text-lg leading-none">
                        @leonardthepreacher
                    </span>
                </div>
                <div className="ml-auto flex items-center gap-2">
                    <span className="hidden md:inline font-chivo text-xs text-white/70 uppercase tracking-wider">
                        Daily · 12:00 AM EST
                    </span>
                    <a
                        data-testid="live-bar-tip-btn"
                        href="https://buymeacoffee.com/leonardthepreacher"
                        target="_blank"
                        rel="noreferrer"
                        title="Send a tip"
                        className="inline-flex items-center gap-1.5 bg-hotpink text-white font-anton uppercase tracking-wider text-sm px-3 py-1.5 border-2 border-black hover:-translate-y-0.5 hover:shadow-[4px_4px_0_#0AC3FF] transition-all"
                    >
                        <Coffee className="w-4 h-4" strokeWidth={3} />
                        <span className="hidden sm:inline">Tip</span>
                    </a>
                    <button
                        data-testid="live-bar-watch-btn"
                        onClick={onWatch}
                        className="bg-kickgreen text-black font-anton uppercase tracking-wider text-sm px-4 py-1.5 border-2 border-black hover:-translate-y-0.5 hover:shadow-[4px_4px_0_#FF2E93] transition-all"
                    >
                        Watch Now
                    </button>
                </div>
            </div>
        </div>
    );
};
